import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';

const ForgotPassword = () => {
    return (
        <div className="login-page-centered" style={{ width: '100%', minHeight: '100vh', background: '#F5F6F8' }}>
            <div
                className="login-page-center-wrap"
                style={{
                    minHeight: '100vh',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '32px 16px',
                    boxSizing: 'border-box',
                }}
            >
                <ForgotPasswordForm />
            </div>
        </div>
    );
};

export default ForgotPassword;
